import { FC } from "react";

import { Icon, IconProps } from "@chakra-ui/icons";

const CustomIcon: FC<Omit<IconProps, "css">> = ({ children, ...props }) => (
  <Icon width="15" height="15" viewBox="0 0 15 15" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.319406 14.8797C0.143271 14.8797 0.000488281 14.7377 0.000488281 14.5631V0.957117C0.000488281 0.78239 0.143271 0.640564 0.319406 0.640564C0.495729 0.640564 0.638512 0.782204 0.638512 0.957117V14.5631C0.638512 14.7378 0.495542 14.8797 0.319406 14.8797Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 14.5631C0 14.3885 0.14297 14.2465 0.319106 14.2465L14.0348 14.2469C14.2112 14.2469 14.3539 14.3885 14.3539 14.5631C14.3539 14.738 14.2112 14.8796 14.0348 14.8796H0.319106C0.14297 14.8796 0 14.7378 0 14.5631Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99147 0.957114C8.99147 1.13203 8.84868 1.27367 8.67236 1.27367H0.319406C0.143271 1.27367 0.000488281 1.13203 0.000488281 0.957114C0.000488281 0.782387 0.143271 0.640747 0.319406 0.640747H8.67236C8.84868 0.640561 8.99147 0.782387 8.99147 0.957114Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0349 5.96027C14.2112 5.96027 14.354 6.10191 14.354 6.27682V14.5633C14.354 14.7379 14.2112 14.8799 14.0349 14.8799C13.859 14.8799 13.7162 14.7379 13.7162 14.5633L13.7158 6.27682C13.7158 6.10191 13.859 5.96027 14.0349 5.96027Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9063 0.0926145C15.0307 0.216224 15.0307 0.416788 14.9063 0.540212L8.99997 6.39988C8.87518 6.52311 8.67319 6.52311 8.54839 6.3995C8.42397 6.27627 8.42397 6.07589 8.54839 5.95209L14.4551 0.0928004C14.5795 -0.0308095 14.7815 -0.0309953 14.9063 0.0926145Z"
      fill="#DC0032"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8234 0.633352C10.6471 0.633167 10.5043 0.491526 10.5039 0.316614C10.5043 0.141887 10.6471 6.10352e-05 10.8234 6.10352e-05H14.6808C14.8571 6.10352e-05 14.9999 0.141701 14.9999 0.316614C14.9999 0.491341 14.8571 0.633352 14.6808 0.633352H10.8234Z"
      fill="#DC0032"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 4.14331C15 4.31804 14.8569 4.46005 14.6809 4.46005C14.5046 4.45987 14.3618 4.31823 14.3618 4.14331V0.316614C14.3618 0.141887 14.5046 6.10352e-05 14.6809 6.10352e-05C14.8569 6.10352e-05 15 0.141701 15 0.316614V4.14331Z"
      fill="#DC0032"
    />
  </Icon>
);

export default CustomIcon;
